/**
 * Utility functions for handling country restrictions
 */

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { Country } from '@workspace/ui/types';
import { forbiddenCountries } from '@/config/forbidden-countries';

/**
 * Checks if a country code is in the forbidden countries list
 * @param {string} countryCode - The ISO country code to check (e.g., "US", "RU")
 * @returns {boolean} True if the country is forbidden, false otherwise
 */
export function isForbiddenCountry(countryCode: string): boolean {
  if (!countryCode) return false;

  const normalizedCode = countryCode.toUpperCase().trim();
  return forbiddenCountries.includes(normalizedCode);
}

/**
 * Checks if a user's country (by country_id) is forbidden
 * @param {number | null | undefined} countryId - The country ID from user verification
 * @param {Country[] | undefined} countries - The list of all countries
 * @returns {boolean} True if the user is from a forbidden country, false otherwise
 */
export function isUserFromForbiddenCountryById(
  countryId: number | null | undefined,
  countries: Country[] | undefined
): boolean {
  // If country_id is null or undefined, allow access (admin case)
  if (!countryId || !countries) return false;

  // Find the country by ID
  const userCountry = countries.find((country) => country.id === countryId);

  if (!userCountry?.iso_code) return false;

  return isForbiddenCountry(userCountry.iso_code);
}

/**
 * Gets a list of all forbidden country codes
 * @returns {string[]} Array of forbidden country codes
 */
export function getForbiddenCountries(): string[] {
  return [...forbiddenCountries];
}
